import { render, staticRenderFns } from "./AddWipTicketPage.vue?vue&type=template&id=5db099c5&scoped=true&"
import script from "./AddWipTicketPage.vue?vue&type=script&lang=ts&"
export * from "./AddWipTicketPage.vue?vue&type=script&lang=ts&"
import style0 from "./AddWipTicketPage.vue?vue&type=style&index=0&id=5db099c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db099c5",
  null
  
)

export default component.exports